/* ==========================================================================
   CTX QR — QR codes for the gym plan export
   ==========================================================================
   window.CTXQR.svg(text, px) -> an SVG string, or '' if it will not fit.

   WHY LOCAL RATHER THAN AN IMAGE SERVICE. The QR on a customer's plan encodes
   their resume link, which contains their entire build. Handing that URL to
   api.qrserver.com or any other generator means a third party receives what our
   customer is shopping for on every single export. It also breaks offline and is
   the sort of thing a CSP quietly kills.

   WHY A LIBRARY RATHER THAN MINE. I wrote a QR encoder for this first — byte
   mode, level L, Reed-Solomon, the lot. It produced structurally plausible codes
   with correct finder patterns and a correct dark module, and it did not scan.
   Rasterising the output and running a real decoder over it returned nothing on
   all three test URLs, while Kazuhiko Arase's library decoded all three exactly.
   Two bugs were visible in a module-level diff (format bits and data placement)
   and there was no reason to believe there were only two.

   A QR that looks right and does not scan is worse than no QR at all: it fails
   silently, in the customer's hand, after the plan has been printed.

   `ctx-qr-lib.js` is that library, MIT, dependency-free, unmodified. It declares
   a top-level `var qrcode`, so in a browser it simply lands on `window`.
   ========================================================================== */
(function () {
  'use strict';

  /* Level L: a printed page is not a scratched parcel label, and L buys the most
     capacity, which matters because the resume URL carries the whole build. */
  var EC_LEVEL = 'L';

  function make(text) {
    if (!window.qrcode || !text) return null;
    try {
      /* typeNumber 0 = pick the smallest version that fits. */
      var q = window.qrcode(0, EC_LEVEL);
      q.addData(text);
      q.make();
      return q;
    } catch (e) {
      /* Thrown when the text exceeds even version 40. Caller degrades to no QR
         rather than an unreadable one. */
      return null;
    }
  }

  function svg(text, px, quiet) {
    var q = make(text);
    if (!q) return '';

    var n = q.getModuleCount();
    var pad = quiet == null ? 4 : quiet;     /* 4 modules is the spec's quiet zone */
    var size = n + pad * 2;

    /* One <path> for every dark module rather than thousands of <rect>s — this
       gets embedded in a print document and rendered by the print engine, and
       fewer nodes is materially faster there. */
    var d = [];
    for (var r = 0; r < n; r++) {
      for (var c = 0; c < n; c++) {
        if (q.isDark(r, c)) d.push('M' + (c + pad) + ' ' + (r + pad) + 'h1v1h-1z');
      }
    }

    return '<svg xmlns="http://www.w3.org/2000/svg" width="' + px + '" height="' + px +
           '" viewBox="0 0 ' + size + ' ' + size + '" shape-rendering="crispEdges" role="img" aria-label="QR code linking back to this gym build">' +
           '<rect width="' + size + '" height="' + size + '" fill="#ffffff"/>' +
           '<path d="' + d.join('') + '" fill="#000000"/>' +
           '</svg>';
  }

  window.CTXQR = { svg: svg, make: make };
})();
